export class SetPasswordModel {
    password: string;
    uid: string;
    Key: string;
}
